<template>
    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.6 2.82353C6.6 2.04485 7.25771 1.41176 8.06667 1.41176C8.87562 1.41176 9.53333 2.04485 9.53333 2.82353V3.52941C9.53333 3.91985 9.86104 4.23529 10.2667 4.23529C10.6723 4.23529 11 3.91985 11 3.52941V2.82353C11 1.26397 9.68687 0 8.06667 0C6.44646 0 5.13333 1.26397 5.13333 2.82353V4.23529H1.46667C0.657708 4.23529 0 4.86838 0 5.64706V10.5882C0 11.3669 0.657708 12 1.46667 12H7.33333C8.14229 12 8.8 11.3669 8.8 10.5882V5.64706C8.8 4.86838 8.14229 4.23529 7.33333 4.23529H6.6V2.82353Z"
            fill="currentColor" />
    </svg>
</template>
